import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import React, { ReactNode, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { getTheme } from "features/apps/global_slice";
import { useSelector } from "react-redux";
import * as Controls from "../components/overrides";

export const darkColors = {
  primary: {
    40: "#6F6B64",
    50: "#8E877B",
    100: "#ECDFC9",
    200: "#D0E1E9",
    300: "#BF8D46",
  },
  secondary: {
    50: "#4D4D4D",
    100: "#626262",
    200: "#3C3C3C",
    300: "#343434",
    350: "#2F2F2F",
    700: "#6E6E6E",
    800: "#7B7B7B",
    900: "#282828",
    950: "#1D1D1D",
  },
  red: {
    300: "#FC8181",
    900: "#ff3974",
    901: "#ff39741c",
  },
  white: "white",
  black: "black",
  org_white: "white",
  org_black: "black",
};

export const lightColors = {
  primary: {
    40: "#6F6B64",
    50: "#8E877B",
    // 100: "#ECDFC9",
    100: "#636e72",
    200: "#D0E1E9",
    300: "#BF8D46",
  },
  secondary: {
    // 50: "white",  // Light grey
    50: "#4D4D4D", // Light grey
    100: "#E6E6E6", // Pale grey
    200: "#D9D9D9", // Medium grey
    // 300: "#CCCCCC", // Cool grey
    // 300: "#f9f9f9",
    // 300: "#bdc3c7",
    300: "#dcdde1",
    350: "#C0C0C0", // Subtle grey
    700: "#B3B3B3", // Muted grey
    800: "#A6A6A6", // Warm grey
    900: "#999999", // Soft dark grey
    // 950: "#8C8C8C", // Neutral grey
    // 950: "#FFFFF0",
    // 950: "#F9F6EE",
    950: "#ecf0f1",
  },
  red: {
    300: "#F56565", // Soft pinkish red
    900: "#E53E3E", // Bright red
    901: "#E53E3E1c", // Transparent red overlay
  },
  white: "black",
  black: "white",
  org_white: "white",
  org_black: "black",
};

export const BaseTheme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: true,
  },
  layerStyles: {
    listPack: {
      cursor: "pointer",
      bg: "secondary.900",
      color: "secondary.100",
      _hover: {
        bg: "secondary.100",
        color: "secondary.900",
      },
      _dark: {
        bg: "secondary.100",
        color: "secondary.900",
        _hover: {
          bg: "secondary.300",
          color: "secondary.900",
        },
      },
    },
    listPackSelected: {
      bg: "secondary.100",
      color: "secondary.900",
      _dark: {
        bg: "secondary.300",
        color: "secondary.900",
      },
    },
    lightButton: {
      bg: "primary.100",
      color: "primary.900",
    },
    cardPack: {
      bg: "secondary.900",
      color: "secondary.100",
      _dark: {
        bg: "secondary.100",
        color: "secondary.900",
      },
    },
    cardPackInverse: {
      bg: "secondary.100",
      color: "secondary.900",
      _dark: {
        bg: "secondary.900",
        color: "secondary.100",
      },
    },
    cardPackHeader: {
      color: "secondary.100",
      _dark: {
        color: "secondary.900",
      },
    },
  },
  textStyles: {
    widerSubHeading: {
      // you can also use responsive styles
      fontSize: "xs",
      letterSpacing: "0.2em",
      textTransform: "uppercase",
    },
  },
  semanticTokens: {
    colors: {
      "chakra-body-text": "primary.100",
      // "chakra-body-bg": "secondary.800",
      // "chakra-border-color": "secondary.400",
      "chakra-placeholder-color": "primary.100",
    },
  },
  styles: {
    global: () => ({
      ".file-input": {
        position: "absolute",
        top: "0%",
        paddingLeft: "var(--input-padding)",
        paddingRight: "40px",
        paddingTop: "12px",
        paddingBottom: "12px",
        width: "100%",
        cursor: "pointer",
        "&:hover": {
          borderColor: "primary.300",
        },
      },
      // "input::file-selector-button": {
      //   display: "none",
      // },
      // "button:hover": {
      //   borderColor: "transparent !important",
      // },
      ".w-full": {
        width: "var(--chakra-sizes-full)",
        textAlign: "left",
      },
      html: {
        height: "100%",
        overflow: "hidden",
      },
      body: {
        height: "100%",
        padding: 0,
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      form: {
        width: "100%",
      },
      // ".color-scroll-container": {
      //   height: "100%",
      //   overflow: "auto",
      //   // scrollbarWidth: "none" /* Firefox */,
      // },
      ".no-scroll-container": {
        height: "100%",
        overflow: "auto",
        scrollbarWidth: "none" /* Firefox */,
      },
      ".no-scroll-container::-webkit-scrollbar": {
        display: "none",
      },
      ".custom-grid": {
        "& .InovuaReactDataGrid__column-header__content": {
          background: "secondary.100",
          margin: 1,
          borderRadius: 5,
        },
        "& .InovuaReactDataGrid__column-header__filter-wrapper": {
          borderTop: 0,
        },
        "& .InovuaReactDataGrid__column-header": {
          alignItems: "flex-start !important",
        },
        "& .InovuaReactDataGrid__header": {
          borderBottom: 0,
        },
      },
      ".entity-select": {
        "& .css-13cymwt-control": {
          borderColor: "secondary.900",
          minHeight: 10,
          background: "none",
        },
        "& .css-4xgw5l-IndicatorsContainer2": {
          background: "none !important",
        },
        "& .css-1u9des2-indicatorSeparator": {
          background: "none",
        },
        "& .css-1xc3v61-indicatorContainer": {
          paddingLeft: 4,
          paddingRight: 4,
        },
        "& .css-feonkk-Input2": {
          color: "var(--chakra-colors-secondary-50)",
        },
      },
      ".custom-svg": {
        "& svg": { fill: "var(--chakra-colors-secondary-50)" },
      },
      "#storybook-root": {
        height: "100%",
        width: "100%",
      },
      ".isolation-auto": {
        // made this class to handle CreatableSelect dropdown overlapping
        isolation: "auto !important",
      },
      "*:focus-visible": {
        boxShadow: "none !important",
      },
      ".rdp": {
        margin: "0!important",
        "--rdp-outline": "2px solid #ebec0c",
        "--rdp-background-color": "none",
        ".rdp-caption": {
          background: "var(--chakra-colors-secondary-400)",
          padding: "var(--chakra-space-2)",
          borderRadius: "var(--chakra-radii-xl)",
        },
        "& .rdp-dropdown": {
          background: "var(--chakra-colors-secondary-400)",
          padding: 4,
          scrollbarWidth: "none" /* Firefox */,
        },
        // ".rdp-button": {
        //   "&:hover": {
        //     background: "var(--chakra-colors-primary-100)!important",
        //   },
        //   "&.rdp-day_selected": {
        //     background: "var(--chakra-colors-blue-300)!important",
        //     color: "var(--chakra-colors-secondary-900)!important",
        //     fontWeight: "bold",
        //   },
        //   "&.rdp-day_today": {
        //     fontWeight: "normal",
        //   },
        //   "&.rdp-day_selected.rdp-day_today": {
        //     background: "var(--chakra-colors-blue-300)!important",
        //     color: "var(--chakra-colors-secondary-900)!important",
        //     fontWeight: "bold",
        //   },
        // },
      },
      ".error .rsw-editor": {
        border: "2px solid var(--chakra-colors-red-600)",
      },
      ".disabled  .rsw-editor": {
        opacity: 0.5,
        "&:hover": {
          border: "2px solid var(--chakra-colors-secondary-600)",
        },
      },
      ".rsw-editor": {
        width: "100%",
        borderRadius: "var(--chakra-radii-xl)",
        border: "2px solid var(--chakra-colors-secondary-400)",

        "&:hover, &:focus, &:focus-within, &:focus-visible": {
          border: "2px solid var(--chakra-colors-blue-300)",
        },
        position: "relative",
        paddingBottom: "50px",
        overflow: "hidden",
        "& .rsw-toolbar": {
          position: "absolute",
          bottom: "0",
          padding: "var(--chakra-space-2)",
          background: "var(--chakra-colors-secondary-400)",
          borderBottom: "0px solid",
          width: "100%",
          "& .rsw-separator": {
            display: "none",
          },
          "& .rsw-btn": {
            background: "var(--chakra-colors-secondary-600)",
            marginRight: "var(--chakra-space-2)",
            borderRadius: "var(--chakra-radii-lg)",
            color: "var(--chakra-colors-secondary-50)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& .rsw-dd": {
            background: "var(--chakra-colors-secondary-600)",
            marginRight: "var(--chakra-space-2)",
            borderRadius: "var(--chakra-radii-lg)",
            padding: "var(--chakra-space-1)",
          },
        },
      },
      ".z-index-5": {
        zIndex: 5,
      },
      ".css-1qq679y": {
        zIndex: "20 !important",
      },
    }),
  },
  fonts: {
    body: "'Poppins', sans-serif",
    heading: "'Poppins', sans-serif",
    mono: "monospace",
  },
  components: {
    ...Controls,
    Text: {
      sizes: {
        h1: {
          fontSize: "40px",
          fontWeight: "bold",
        },
        h2: {
          fontSize: "32px",
          fontWeight: "bold",
        },
        h4: {
          fontSize: "24px",
          fontWeight: "bold",
        },
        h5: {
          fontSize: "20px",
          fontWeight: "bold",
        },
        h6: {
          fontSize: "16px",
          fontWeight: "bold",
        },
      },
    },
  },
});

const BaseProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(BaseTheme);
  const colorMode = useSelector(getTheme);

  // const colorMode = "dark"

  // console.log("=-=-=", colorMode)

  useEffect(() => {
    if (colorMode === "light") {
      const updatedTheme = {
        ...BaseTheme,
        colors: lightColors,
      };
      setCurrentTheme(updatedTheme);
    } else if (colorMode === "dark") {
      const updatedTheme = {
        ...BaseTheme,
        colors: darkColors,
      };
      setCurrentTheme(updatedTheme);
    }
  }, [colorMode]);

  return <ChakraProvider theme={currentTheme}>{children}</ChakraProvider>;
};

export default BaseProvider;
